import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import AboutFour from "../Components/About/AboutOne";
import TourOne from "../Components/Tour/TourOne";
import TestimonialOne from "../Components/Testimonials/TestimonialOne";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <>
      <Helmet>
        <title>About Us | Howly Wizard</title>
      </Helmet>
      <HeaderOne />
      <Breadcrumb title="About Us" />
      <AboutFour />
      <TourOne />
      <TestimonialOne />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default About;
